import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'auth',
  initialState: {
    adminScanCenterAuth: false,
    token: '',
    loginError: '',
    loginLoading: false,
  },
  reducers: {
    fetchScanCenterUserLogin: (state) => {
      let data = localStorage.getItem('adminScanCenterAuth')
      let token = localStorage.getItem('adminScanCenterToken')
      const scanCenterExpirationDate = localStorage.getItem('scanCenterExpirationDate')
      if (!token || !scanCenterExpirationDate || !data) {
        return { ...state, adminScanCenterAuth: false, token: '' } // Set to false instead of null
      }
      const now = new Date()
      const expiry = new Date(scanCenterExpirationDate)
      if (now >= expiry) {
        localStorage.removeItem('adminScanCenterAuth')
        localStorage.removeItem('adminScanCenterToken')
        localStorage.removeItem('scanCenterExpirationDate')
        return { ...state, adminScanCenterAuth: false, token: '' } // Set to false instead of null
      }
      let parsedData = JSON.parse(data)
      return { ...state, adminScanCenterAuth: parsedData, token: token } // Return new state object
    },
    userScanCenterLogin: (state, { payload }) => {
      state.loginLoading = true
      state.loginError = ''
    },
    userScanCenterLoginSuccess: (state, { payload: { payload } }) => {
      let data = JSON.stringify(payload?.data)

      const now = new Date()
      const scanCenterExpirationDate = new Date(now.getTime() + 5 * 24 * 60 * 60 * 1000)
      localStorage.setItem('adminScanCenterAuth', data)
      localStorage.setItem('adminScanCenterToken', payload.data.access_token)
      localStorage.setItem('scanCenterExpirationDate', scanCenterExpirationDate.toISOString())
      state.loginLoading = false
      state.adminScanCenterAuth = payload.data
      state.token = payload.data.access_token
    },
    userScanCenterLoginFailed: (state, { payload }) => {
      state.token = '' // Use an empty string instead of null for consistency
      state.loginLoading = false
      state.loginError = payload.message
    },

    adminScanCenterLogoutFunc: (state) => {
      localStorage.removeItem('adminScanCenterAuth')
      localStorage.removeItem('adminScanCenterToken')
      localStorage.removeItem('sanCenterExpirationDate')
      return { ...state, adminScanCenterAuth: false, token: '' }
    },
  },
})

export const {
  adminScanCenterLogoutFunc,
  fetchScanCenterUserLogin,
  userScanCenterLogin,
  userScanCenterLoginSuccess,
  userScanCenterLoginFailed,
} = slice.actions

export default slice.reducer
